/*
 *==================================================
 * Licensed Materials - Property of HCL Technologies
 *
 * HCL Commerce
 *
 * (C) Copyright HCL Technologies Limited 2020
 *
 *==================================================
 */

const RequiredLabel = () => {
  return (
    <p className="red-required-label">
      <span>*</span> Campo Obligatorio
    </p>
  );
};

export default RequiredLabel;
